import { inject, observer } from "mobx-react";
import * as React from 'react';
import { Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import ButtonRow from 'src/Components/ButtonRow';
import DataTable from 'src/Components/DataTable';
import EInput, { EButton } from 'src/Components/EInput';
import { GroupEmail } from 'src/Interfaces/AdminInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from "src/UtilityFunctions/DeepCopy";

@inject('stores')
@observer
export class AdminGroupEmail extends React.Component {
    public props: any;
    private AdminStore: AdminStore;
    private UserStore: UserStore;
    private MessageStore: MessageStore;
    private adminGroupEmailHeader = [
        "Group Email",
        "Description",
    ];

    public state = {
        editing: false,
        groupEmail: new GroupEmail(),
        groupEmailModal: false,
        groupEmails: [] as GroupEmail[],
        rowIndex: 0,
    };

    constructor(props: any) {
        super(props);
        this.AdminStore = props.stores.AdminStore;
        this.UserStore = props.stores.UserStore;
        this.MessageStore = props.stores.MessageStore;
    }

    public componentDidMount() {
        this.AdminStore.getTenantGroupEmails().
            then(groupEmails => {
                this.setState({groupEmails});
            });

        if (!this.UserStore.user) {
            this.UserStore.getProfile();
        }
    }

    private formatGroupEmailsData = () => {
        const adminGroupEmails = this.state.groupEmails;
        const rows = [] as any[];
        adminGroupEmails.forEach(groupEmail => {
            const tempRow = [
                {
                    content: groupEmail.email
                },
                {
                    content: groupEmail.description,
                }
            ];
            rows.push(tempRow);
        });
        return { headers: this.adminGroupEmailHeader, rows };
    }

    private addGroupEmail = (addAnother: boolean) => () => {
        const {groupEmail, groupEmails, editing, rowIndex } = this.state;
        if (editing) {
            groupEmails[rowIndex] = groupEmail;
        } else {
            groupEmails.push(groupEmail);
        }
        if (addAnother) {
            this.setState({groupEmail: new GroupEmail(), groupEmails});
        } else {
            this.setState({editing: false, groupEmail: new GroupEmail(), groupEmailModal: false, groupEmails});
        }
    }

    public onEditGroupEmail = (index: number) => {
        this.setState({editing: true, groupEmail: DeepCopy(this.state.groupEmails[index]), groupEmailModal: true, rowIndex: index});
    }

    public toggleGroupEmail = () => {
        this.setState({groupEmailModal: !this.state.groupEmailModal, groupEmail: new GroupEmail()});
    }

    public onDeleteGroupEmail = (index: number) => {
        const groupEmails = this.state.groupEmails;
        groupEmails.splice(index, 1);
        this.setState({groupEmails});
    }

    private handleGroupEmailChange = (event: any) => {
        const groupEmail = this.state.groupEmail;
        groupEmail[event.target.name] = event.target.value;
        this.setState({groupEmail});
    }

    private saveGroupEmails = () => {
        this.AdminStore.postTenantGroupEmails(this.state.groupEmails)
            .then(data => {
                this.MessageStore.addMessage('Internal Distribution Email List Saved.', 'success');
            });
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Internal Distribution Emails</h1>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable 
                            list={this.formatGroupEmailsData()}
                            onNew={this.UserStore.hasPermission('Permissions.Admin.InternalEmails.Create') ? {
                                callback: this.toggleGroupEmail,
                                text: 'Add New Internal Email'
                            } : undefined}
                            onEdit={this.UserStore.hasPermission('Permissions.Admin.InternalEmails.Update') ? this.onEditGroupEmail : undefined}
                            onDelete={this.UserStore.hasPermission('Permissions.Admin.InternalEmails.Delete') ? this.onDeleteGroupEmail : undefined}
                        />
                    </Col>
                </Row>
                {
                    ( this.UserStore.hasPermission('Permissions.Admin.InternalEmails.Create')
                    || this.UserStore.hasPermission('Permissions.Admin.InternalEmails.Update')
                    || this.UserStore.hasPermission('Permissions.Admin.InternalEmails.Delete')
                    )
                    &&
                    <ButtonRow>
                        <Button color="primary" onClick={this.saveGroupEmails}>Save Internal Distribution Email Lists</Button>
                    </ButtonRow>
                }
                <Modal isOpen={this.state.groupEmailModal} toggle={this.toggleGroupEmail}>
                    <ModalHeader toggle={this.toggleGroupEmail}>
                        Add/Edit Internal Distribution Email
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Label>Email</Label>
                                <EInput
                                    name="email"
                                    id="email"
                                    value={this.state.groupEmail.email}
                                    onChange={this.handleGroupEmailChange}
                                    data-validation="email"
                                    required={true}
                                />
                                <Label>Description</Label>
                                <EInput
                                    name="description"
                                    id="description"
                                    value={this.state.groupEmail.description}
                                    onChange={this.handleGroupEmailChange}
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleGroupEmail}>Cancel</Button>
                        <EButton color="primary" onClick={this.addGroupEmail(false)}>Save</EButton>
                        <EButton color="primary" onClick={this.addGroupEmail(true)}>Add Another</EButton>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default AdminGroupEmail;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/GroupEmail/AdminGroupEmail.tsx